import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react';

	const BarGraph = props => {

	const { visible, text, level, article } = props;
	const { bLogo, bName } = visible;

	const [bar, setBar] = useState(level);

	const [foo, setFoo] = useState(0);

	const unset = () => {
		setFoo(0);
	}
	useEffect(()=>{ article === 'skills' ? setTimeout(() => {
			const interval = setInterval(()=>{
			    if (foo <= bar - 3) {
			      setFoo(old => {
			        const newValue = ++old;
			        //console.log(`${old} old`);
			        //console.log(`${newValue} new"`);
			        return newValue;
			        });
			      }
			   clearInterval(interval);
			},1);
	    }, 200) : unset();
	});

	return (
		<div className="chart-item" >
            <div className={`${text}-bg box`} style={{width:`${foo}%`}}>
              <span className={`icon fab fa-${text}`} style={{opacity: `${foo >= bLogo ? '1' : '0' }`}}></span>
              <h4 style={{opacity: `${foo >= bName ? '1' : '0' }`}}>{text}</h4>
            </div>
            <h4 className="percentage">{ foo }%</h4>
        </div>
	);
}

BarGraph.propTypes = {
  article: PropTypes.string,
  text: PropTypes.string,
  bg: PropTypes.string,
  level: PropTypes.number,
  visible: PropTypes.object
}

export default BarGraph 